import { render, staticRenderFns } from "./ConfirmationDeleteModal.vue?vue&type=template&id=70b88000&"
import script from "./ConfirmationDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationDeleteModal.vue?vue&type=style&index=0&id=70b88000&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports